import {
  HttpEvent, HttpHandler,

  HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MssServiceFactory } from './mss-service.factory';

@Injectable()
export class MSSErrorInterceptor implements HttpInterceptor {

  // Service interceptant les appel http afin de vérifier s'il y a bien un token d'identification

  constructor(
    private _mssSrv: MssServiceFactory,
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.includes(`${environment.basePath}`) && req.url.includes(`${environment.basePath}/messagerie`)) {
      return from(next.handle(req)).pipe(
        catchError((err) => {
          // this.httpErrorService.handleError(err.error);
          console.error('ERREUR MSS', err);
          if (err.status === 403) {
            this._mssSrv.getService().authenticationErrorSubject.next(false);
            throw err;
          }
          throw err;
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
